import type { Transactable } from '@src/domains/transactables';

// How this feature addresses a transactable when it files its payment options — the slice uses it
// as a cache key, so two different transactables never share an entry. Same precedence as
// isTransactablePayable, so a sale change gets its own entry instead of reading the order's.
export const resolveTransactableKey = (tr: Transactable): string => {
  if (tr.saleChange) {
    return `saleChange_${tr.saleChange.id}`;
  }
  if (tr.order) {
    return `order_${tr.order.id}`;
  }
  if (tr.sale) {
    return `sale_${tr.sale.id}`;
  }
  if (tr.directLink) {
    return `directLink_${tr.directLink.code}`;
  }
  return '';
};
